import { Dispatch, SetStateAction } from 'react';
import { Row } from 'react-table';
import { AxiosError } from 'axios';
import { OnboardingList } from '@/types/common';
import { OptionType } from '@bureau/components/src';

export interface AdminListContentProps {
  data: OnboardingList[];
  isLoading: boolean;
  error: AxiosError | null;
  filterField: string;
  setOpenGenerateKeyDialog: Dispatch<SetStateAction<boolean>>;
  generateApiKey: Function;
  searchTerm: string;
  handleActionButtonClick: (e: Row, type: string) => void;
  onApiKeyToggle: (val: string) => void;
  setShowGenerateApiKeymodal: Dispatch<SetStateAction<boolean>>;
}

export interface DeleteApiKeyDetails {
  credentialId: string;
  showPopup: boolean;
  action: string;
}

interface UserPermission {
  description: string;
  permission_name: string;
}

export interface UserRole extends OptionType {
  name: string;
  id: string;
  description?: string;
  permissions?: UserPermission[];
}

export interface UserListResponse {
  user_id: string;
  name: string;
  email: string;
  roles: UserRole[];
  status?: string;
}

export interface UserInvitationResponse {
  inviter: { name: string };
  invitee: { email: string };
  roles: string[];
}

export interface UserFilterField {
  roles?: string[];
  status?: string[];
}
export interface UserListContentProps {
  setFilterFields: Dispatch<SetStateAction<UserFilterField>>;
  filterFields: UserFilterField;
  data: UserListResponse[];
  isLoading: boolean;
  error: AxiosError | null;
  setSortField: Dispatch<SetStateAction<{ field: string; order: string }>>;
  offset: number;
  setOffset: (item: number) => void;
  setOpenUserActionDialog: Function;
  handleActionButtonClick: (e: Row, type: string) => void;
  inviteUserPermission: boolean;
  userPermissions: string[];
  searchTerm?: string;
  setUserDetails: (data: UserDetailsProps) => void;
}

export interface UserDetailsProps {
  email: string;
  roles: (string | undefined)[];
  user_id?: string;
  name?: string;
  invitation_id?: string;
}

export interface EditUserDialogProps {
  openDialog: boolean;
  setOpenDialog: Function;
  userDetails: UserDetailsProps;
  setUserInvited: Function;
}

export interface DeleteUserDialogProps {
  setOpenDeleteUserDialog: Function;
  userDetails: UserDetailsProps;
  setUserInvited: Function;
}
export interface InviteUserProps {
  name?: string;
  invitee: string;
  inviter: string;
  roles?: string[];
}

export interface RolesList extends OptionType {
  role?: string;
  value: string;
  name: string;
  id: string;
  description?: string;
}

export enum ToastMessage {
  APIKEY_DELETED_MESSAGE = 'Api Key deleted successfully',
  ERROR_MESSAGE = 'Some error occurred. Please try after some time.',
  WARNING_MESSAGE = 'Something went wrong',
}

export interface OrganizationDetails {
  'Display name': string;
  id: string;
}
